import { render, staticRenderFns } from "./BlackFridayEmailRoadblock.vue?vue&type=template&id=53d0b9c0&scoped=true&"
import script from "./BlackFridayEmailRoadblock.vue?vue&type=script&lang=js&"
export * from "./BlackFridayEmailRoadblock.vue?vue&type=script&lang=js&"
import style0 from "./BlackFridayEmailRoadblock.vue?vue&type=style&index=0&id=53d0b9c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d0b9c0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/app/appsumo/nuxt/components/wishlists/Button.vue').default})
